export default "__VITE_ASSET__Cpg2gS9k__"